import { render, staticRenderFns } from "./widget-textarea.vue?vue&type=template&id=ed3d4360&scoped=true"
import script from "./widget-textarea.vue?vue&type=script&lang=js"
export * from "./widget-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3d4360",
  null
  
)

export default component.exports